import { MatxLoadable } from "matx";

const Home = MatxLoadable({
  loader: () => import("./Home")
});

const Form = MatxLoadable({
  loader: () => import("./Form")
});

const TrainingThankYou = MatxLoadable({
  loader: () => import("./ThankYouTraining")
});

const lssRoutes = [
  {
    path: "/lss/form",
    component: Form
  },
  {
    path: "/lss",
    component: Home
  },
  {
    path: "/ThankYouTraining",
    component: TrainingThankYou
  }
];

export default lssRoutes;
